import React, { useState, useEffect } from 'react';

const Footer = () => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const formatTime = (date) => {
    return date.toLocaleTimeString('it-IT', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const services = [
    'Social Media Management',
    'Lead Generation',
    'Content Creation',
    'Influencer Marketing',
    'Supporto Legale',
    'Business Administration'
  ];

  const resources = [
    { name: 'Servizi', id: 'servizi' },
    { name: 'Chi Siamo', id: 'chi-siamo' },
    { name: 'Case Studies', id: 'case-studies' },
    { name: 'Contatti', id: 'contatti' }
  ];

  return (
    <footer className="relative bg-black border-t border-white/10 py-16">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-t from-blue-950/10 to-transparent" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Colonna 1: Company Info */}
          <div className="space-y-4">
            <h3 className="text-white text-xl font-bold tracking-wider">
              SL MANAGEMENT
            </h3>
            <p className="text-gray-400 text-sm">
              info@slmanagement.it
            </p>
          </div>

          {/* Colonna 2: Services (non clickabili) */}
          <div>
            <h4 className="text-gray-500 text-sm font-semibold uppercase tracking-wider mb-4">
              SERVIZI
            </h4>
            <ul className="space-y-2">
              {services.map((service, index) => (
                <li key={index} className="text-gray-400 text-sm">
                  {service}
                </li>
              ))}
            </ul>
          </div>

          {/* Colonna 3: Resources (clickabili - anchor links) */}
          <div>
            <h4 className="text-gray-500 text-sm font-semibold uppercase tracking-wider mb-4">
              RISORSE
            </h4>
            <ul className="space-y-2">
              {resources.map((resource, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection(resource.id)}
                    className="text-gray-400 hover:text-white transition-colors text-sm text-left"
                  >
                    {resource.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Colonna 4: Time */}
          <div>
            <h4 className="text-gray-500 text-sm font-semibold uppercase tracking-wider mb-4">
              ORARIO LOCALE
            </h4>
            <div className="text-white text-4xl font-bold font-mono">
              {formatTime(time)}
            </div>
            <div className="text-gray-500 text-sm mt-2">
              Milano, Italia
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-8 border-t border-white/10 text-center space-y-1">
          <p className="text-gray-500 text-sm">
            SL Management, © 2026. Tutti i diritti riservati.
          </p>
          <p className="text-gray-500 text-sm">
            SL Srl, P.IVA e C.F. 03186140301
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
